import { Bell, Cpu, Home, Landmark, Store, UserRound } from "lucide-react";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, Navigate, NavLink, Outlet } from "react-router-dom";
import { engagementApi } from "../api/engagement";
import { configApi } from "../api/config";
import { normalizeUser } from "../api/user";
import { BrandMark } from "../components/BrandMark";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { useCopy } from "../i18n/copy";
import { useSession } from "../store/session";

const navItems = [
  { to: "/", label: "Inicio", icon: Home, end: true },
  { to: "/market", label: "Mercado", icon: Store },
  { to: "/miners", label: "Mis equipos", icon: Cpu },
  {
    to: "/finance",
    label: "Finanzas",
    icon: Landmark,
    requiresFinanceMenu: true,
  },
  { to: "/account", label: "Cuenta", icon: UserRound },
];

export function AppShell() {
  const { tr } = useCopy();
  const { isPreview, setSession } = useSession();
  const user = useQuery({
    queryKey: ["session-user"],
    queryFn: engagementApi.userDetails,
    enabled: !isPreview,
    refetchInterval: 60000,
  });
  const appConfig = useQuery({
    queryKey: ["app-config"],
    queryFn: configApi.app,
    refetchInterval: 60000,
  });
  const visibleNavItems = navItems.filter(
    (item) =>
      !item.requiresFinanceMenu || appConfig.data?.showFinanceMenu === true,
  );

  useEffect(() => {
    if (user.data) setSession(normalizeUser(user.data));
  }, [setSession, user.data]);

  if (isPreview) return <Navigate to="/auth/login" replace />;

  return (
    <div className="app-frame">
      <a className="skip-link" href="#main-content">
        {tr("Saltar al contenido")}
      </a>
      <aside className="desktop-sidebar">
        <BrandMark />
        <nav aria-label={tr("Navegación principal")}>
          {visibleNavItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <Icon size={21} />
              <span>{tr(label)}</span>
            </NavLink>
          ))}
        </nav>
        <LanguageSwitcher />
      </aside>

      <div className="app-column">
        <header className="mobile-topbar">
          <BrandMark />
          <div className="topbar-actions">
            <Link
              className="icon-button"
              to="/messages"
              aria-label={tr("Notificaciones")}
            >
              <Bell size={21} />
            </Link>
            <LanguageSwitcher compact />
          </div>
        </header>
        <main id="main-content">
          <Outlet />
        </main>
        <nav className="bottom-nav" aria-label={tr("Navegación principal")}>
          {visibleNavItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              {({ isActive }) => (
                <>
                  <span className={isActive ? "nav-icon active" : "nav-icon"}>
                    <Icon size={22} />
                  </span>
                  <small>{tr(label)}</small>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
